import { defineStore } from 'pinia'
import { ref } from 'vue'
import { CultureApi } from 'vantis.process'
const formLocalizations = ref<Record<string, any>>({ } );
export const useDynamicFormCultureStore = defineStore("DynamicFormCulture", ()=>{
  const api = new CultureApi();
  async function getCulture(lang:string){
    if(!formLocalizations.value[lang])
    {
      const response = await api.processApiCultureGetCultureGet();
      if(response.data){
        formLocalizations.value[lang] = response.data;
      }
    }
    return formLocalizations.value[lang];
  }
  return {getCulture}
})